module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_33.99bd5b4e.mp3";